<template>
  <button
    class="icon relative h-10 w-10 cursor-pointer rounded-sm hover:bg-grey-hover active:bg-primary/10"
  >
    <slot>
      <icon-base
        class="icon-base absolute inset-1/2 -translate-x-1/2 -translate-y-1/2 transform text-grey-icon"
        :view-box="viewBox"
        height="24"
        width="24"
        :icon="icon"
      />
    </slot>
  </button>
</template>
<script setup lang="ts">
import type { Component, ComponentOptions } from "vue";

withDefaults(
  defineProps<{
    icon?: string | (ComponentOptions | ComponentOptions["setup"]) | Component;
    width?: string | number;
    height?: string | number;
    viewBox?: string;
  }>(),
  {
    width: 24,
    height: 24,
  }
);
</script>
<style scoped>
@reference "@/assets/tailwind.css";

button:active svg {
  @apply text-primary;
}
.icon:focus,
.icon:focus-visible {
  @apply ring ring-primary/30 outline-hidden;
}
</style>
